import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartSheet } from "@/components/CartSheet";
import { WoodCalculator } from "@/components/WoodCalculator";
import { Reveal } from "@/components/Reveal";

export default function Calculadora() {
    return (
        <div className="bg-crema min-h-screen">
            <Navbar />
            <CartSheet />
            <div className="pt-16 md:pt-20">
                <div className="hero-gradient text-white">
                    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
                        <span className="text-xs uppercase tracking-[0.2em] font-semibold text-madera">Herramienta gratuita</span>
                        <h1 className="font-display font-extrabold text-4xl md:text-6xl mt-2 tracking-tight">Calculadora de madera</h1>
                        <p className="text-white/75 mt-4 max-w-xl">Dinos el tamaño de tu proyecto y te decimos cuántas tablas de pino necesitas — con margen de desperdicio y precio estimado.</p>
                    </div>
                </div>
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                    <Reveal>
                        <WoodCalculator />
                    </Reveal>
                    <p className="text-xs text-mut mt-4 text-center">* El estimado es referencial. Considera cortes y uniones según tu diseño.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
